<template>
    <b-modal 
        size="lg" 
        no-close-on-backdrop 
        centered
        hide-footer
        title="Atualização de valores da carteira"
        v-model="open"
    >
        <div class="d-block text-center">
            <h4>Digite abaixo o novo valor e/ou a nova data para o vencimento!</h4>
        </div>
        
        <div class="d-block text-center mb-4">
            <h5 
                class="text-danger mt-4 mb-3"
                v-if="data.block == 1"  
            >
                Esse usuário esta bloqueado, para realizar alguma ação aqui, favor desbloquear o mesmo
            </h5>

            <h5 v-if="data.client" class="mt-3 text-secondary">{{data.client.first_name}} {{data.client.last_name}}</h5>
            <h5 v-if="data.professional" class="mt-3 text-secondary">{{data.professional.name}}</h5>
            <h5 v-if="data.company" class="mt-3 text-secondary">{{data.company.nome_fantasia}}</h5>
        </div>   

        <div class="row">
          <b-col cols="12" md="6" class="col">
            <label>Crédito atual do cliente</label>
            <div class="input-group mb-3">
              <div class="input-group-append">
                <span class="input-group-text" id="value-total">R$</span>
              </div>
              <input 
                :disabled="data.block == 1 ? true : false "
                v-model="limit"
                type="text" 
                class="form-control" 
                placeholder="Digite o valor" 
                aria-describedby="value-total"
                v-mask="['#,##','##,##','###,##','####,##','#####,##', '######,##']"
              >
            </div>
          </b-col>  

          <b-col cols="12" md="6" >
            <label>Dia do vencimento</label>
            <v-select
              class="select"
              v-model="due"
              :options="day"
              label="Label"
              :disabled="data.block == 1 ? true : false "
              >
              <div slot="no-options">
              Selecione um número de 1 até 28!
              </div>
          </v-select>
          </b-col>  

          <b-col cols="12" md="6" class="mt-3">
            <label>Valor em aberto</label>
            <div class="input-group mb-3">
              <div class="input-group-append">
                <span class="input-group-text">R$</span>
              </div>
              <input 
                v-model="data.spent" 
                type="number" 
                class="form-control" 
                disabled
              > 
            </div>
          </b-col>

          <b-col cols="12" md="6" class="mt-3">
            <label>Saldo Atual</label>
            <div class="input-group mb-3">
              <div class="input-group-append">
                  <span class="input-group-text">R$</span>
              </div>
              <input 
                v-model="data.balance" 
                type="number" 
                class="form-control" 
                disabled
              >
            </div>
          </b-col>
        </div>

        <div class="row container d-flex end">
            <button 
                v-if="data.block == 0" 
                class="mt-3 btn btn-success" 
                @click="edit()"
            >
                Atualizar
            </button>
            <button 
                v-if="data.block == 0" 
                class="mt-3 ml-3 btn btn-danger" 
                @click="open = false"
            >
                Fechar
            </button>
        </div>
    </b-modal>
</template>

<script>
import makeToast from '@/mixins/makeToast';
import {mapActions, mapState } from 'vuex';

export default {
    name:'EditValue',
    emits:['getAllClient'],
    mixins: [makeToast],

    data() {
        return  {
            open: false,
            loading: false,
            data: [],
            due: '',
            limit: '',
            day:[],
        }
    },

    computed: {
        ...mapState(['dadosUsuario']),
    },

    methods: {
        ...mapActions('shopkeeper', [
            'updateWallet',
        ]),

        toggleOpen(client = []) {
            this.open = !this.open;
            this.data = client;
            this.limit  = this.data.limit * 100;
            this.due = this.data.due;
            this.daysDue();
        },

        daysDue(){
            for (let index = 0; index < 28; index++ ) {
                this.day[index] = index +1;        
            }
        },

        edit(){
            let value = this.limit.replaceAll(',','');
            let newLimit = value/100;

            const data = {
                limit: newLimit,
                due: this.due,
                balance: newLimit - this.data.spent,
                id: this.data.id
            }

            if(data.limit == 0 || data.limit < 0){
                this.makeToast(
                'Erro',
                'O limite não pode ser menor ou igual a 0',
                'danger'
                );
                return
            }

            this.$store.dispatch('startLoader');
            this.updateWallet(data)
            .then((response) => {
                this.makeToast(
                'Sucesso',
                'Dados atualizados com sucesso!',
                'success'
                );
                this.open = false;
                this.$emit('getAllClient');
            })
            .catch(() => {
                this.makeToast(
                'Erro',
                'Houve um erro Atualizar os dados',
                'danger'
                );
            })
            .finally(() => {
                this.$store.dispatch('endLoader');
            });
            },
    }
}
</script>